import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import {
  RESUME,
  VALIDATION_ERROR
} from '../../constants/login/login-remember-me-constant';
import {
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentialsResponse,
  LoginOAuthParams,
  RedirectfulResponse
} from '../../models/login';
import { LoginPostWithCredService } from '../../services/login/data-services/login-post-with-cred/login-post-with-cred-service';
import { LoginRememberMeErrorUtilService } from '../../utils/login/login-remember-me-error-util.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectfulPostWithCredentialsFacadeService {
  flowId = '';

  constructor(
    private loginPostWithCred: LoginPostWithCredService,
    private LoginRememberMeErrorUtil: LoginRememberMeErrorUtilService
  ) {}

  redirectfulPostWithCredFlow(
    loginOAuthParams: LoginOAuthParams,
    requestInput: ILoginUserNamePasswordInput
  ): Observable<RedirectfulResponse | string> {
    return this.loginPostWithCred
      .loginPostWithCredentials(
        loginOAuthParams.oauthConfig,
        this.flowId,
        requestInput
      )
      .pipe(
        concatMap((response: LoginAuthWithCredentialsResponse) => {
          if (response.status === RESUME) {
            return of({
              resumeUrl: response.resumeUrl ? response.resumeUrl : ''
            });
          } else if (response.code === VALIDATION_ERROR) {
            return throwError(response);
          } else {
            return throwError(response);
          }
        }),
        catchError((error) => {
          return of(
            this.LoginRememberMeErrorUtil.checkRememberMeErrors(
              loginOAuthParams.oauthConfig,
              error
            )
          );
        })
      );
  }
}
